<template>
  <div class="app">
    <AppHeader ref="header" />
    <div class="app-body">
      <AppSidebar/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">

          <router-view></router-view>

        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import AppHeader from '@/containers/layout/Header'
import AppSidebar from '@/containers/layout/Sidebar'
import AppAside from '@/containers/layout/Aside'
import AppFooter from '@/containers/layout/Footer'
import Breadcrumb from '@/containers/layout/Breadcrumb'

import PermissionMixin from '@/store/module/permission/mixin'
import { actionTypes as PermissionActions } from '@/store/module/permission/actions'

export default {
  name: 'full',
  mixins: [ PermissionMixin ],
  components: {
    AppHeader,
    AppSidebar,
    AppAside,
    AppFooter,
    Breadcrumb
  },
  computed: {
    name () {
      return this.$route.name
    },

    list () {
      return this.$route.fullPath.split('/')
      // return this.$route.matched
    }
  },
  mounted () {
    this[PermissionActions.GET_ALL_PERMISSIONS]()
      .then((response) => {
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/PrivateBaseLayout.vue